import React from 'react';
import styled from 'styled-components';

import { FaFacebook, FaTiktok, FaTwitter } from 'react-icons/fa';

const Container = styled.div`
    width: 75%;
    margin: 2rem auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
`

const Left = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`

const IconList = styled.div`
    display: flex;
    align-items: center;
    margin: 1rem auto;
    
    &>* {
        padding-right: 1rem;
        transform: all 0.2s ease;
        font-size: 1.5rem;
        
        &:hover {
            transform: scale(1.2);
        }
}`

const Menu = styled.ul`
    display: flex;
    justify-content: space-between;
    align-items: center;
    list-style: none;
`

const MenuItem = styled.li`
    margin: 0 1rem;
    color: ${props => props.theme.text};
    cursor: pointer;

    &::after {
        content: ' ';
        display: block;
        width: 0%;
        height: 2px;
        background: ${props => props.theme.text};
        transition: width 0.3s ease;
    }

    &:hover::after {
        width: 100%;
    }
`

const Trademark = styled.div`
    color: ${(props) => `rgba(${props.theme.textRgba}, 0.6)`};;
`

const Footer = () => {

    const scrollTo = (id) => {
        let element = document.getElementById(id);

        element.scrollIntoView({
            behaviour: 'smooth',
            block: 'start',
            inline: 'nearest'
        })
    }

    return (
        <Container>
            <Menu>
                <MenuItem onClick={() => scrollTo('home')}>Home</MenuItem>
                <MenuItem onClick={() => scrollTo('about')}>About</MenuItem>
                <MenuItem onClick={() => scrollTo('team')}>Team</MenuItem>
                <MenuItem onClick={() => scrollTo('faq')}>Faq</MenuItem>
            </Menu>
            <Left>
                <IconList>
                    <a href="/" target='_blank' rel="">
                        <FaFacebook />
                    </a>
                    <a href="/" target='_blank' rel="">
                        <FaTiktok />
                    </a>
                    <a href="/" target='_blank' rel="">
                        <FaTwitter />
                    </a>
                </IconList>
            </Left>
            <Trademark>© 2022 JollyShow. All rights reserved.</Trademark>

        </Container>
    )
}
export default Footer;